import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../context/axios";
import { Toaster, toast } from "react-hot-toast";

const getAllowedStatusOptions = (currentStatus) => {
  switch (currentStatus) {
    case "received":
      return ["received", "in progress", "book", "cancel", "done"];
    case "in progress":
      return ["in progress", "book", "cancel", "done"];
    case "book":
      return ["book", "cancel", "done"];
    case "cancel":
    case "done":
      return [currentStatus]; // no changes allowed
    default:
      return ["received", "in progress", "book", "cancel", "done"];
  }
};

const Reservations = () => {
  const [reservations, setReservations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchReservations = async () => {
      try {
        const response = await axios.put(
          `/tours/tourReservations?page=${currentPage}`
        );
        setReservations(response.data.data);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        toast.error("Failed to load reservations");
      }
    };
    fetchReservations();
  }, [currentPage]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="min-h-screen py-2 px-2 ">
      <Toaster position="top-right" />
      <div className="max-w-7xl mx-auto p-6  rounded-lg ">
        <h2 className="text-4xl font-extrabold  text-indigo-600 mb-8">
          Reservations
        </h2>
        <div className="overflow-x-auto border border-gray-200 rounded-lg">
          <table className="min-w-full text-sm bg-white divide-y divide-gray-200">
            <thead className="bg-indigo-50 text-indigo-600">
              <tr>
                <th className="px-6 py-3 text-left">Sr No</th>
                <th className="px-6 py-3 text-left">Tour Title</th>
                <th className="px-6 py-3 text-left">Image</th>
                <th className="px-6 py-3 text-left">Name</th>
                <th className="px-6 py-3 text-left">Email</th>
                <th className="px-6 py-3 text-left">Mobile</th>
                <th className="px-6 py-3 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {reservations.map((r, i) => (
                <tr
                  key={r._id}
                  className="hover:bg-indigo-50 transition-colors"
                >
                  <td className="px-6 py-3 text-gray-800">
                    {(currentPage - 1) * 10 + i + 1}
                  </td>
                  <td className="px-6 py-3 font-medium text-gray-900">
                    {r.tourId?.title || "—"}
                  </td>
                  <td className="px-6 py-3">
                    {r.tourId?.img ? (
                      <img
                        src={r.tourId.img}
                        alt="Tour"
                        className="w-16 h-16 object-cover rounded"
                      />
                    ) : (
                      <span className="text-gray-400">No image</span>
                    )}
                  </td>
                  <td className="px-6 py-3">
                    {r.userId?.name || r.fullName || "—"}
                  </td>
                  <td className="px-6 py-3">
                    {r.userId?.email || r.email || "—"}
                  </td>
                  <td className="px-6 py-3">
                    {r.userId?.mobile || r.phone || "—"}
                  </td>
                  <td className="px-6 py-3">
                    <select
                      value={r.status}
                      onChange={async (e) => {
                        const newStatus = e.target.value;
                        try {
                          await axios.put(
                            `/tours/tourReservations/${r._id}/status`,
                            { status: newStatus }
                          );
                          setReservations((prev) =>
                            prev.map((res) =>
                              res._id === r._id
                                ? { ...res, status: newStatus }
                                : res
                            )
                          );
                          toast.success("Status updated!");
                        } catch {
                          toast.error("Status update failed");
                        }
                      }}
                      className="px-4 py-2 rounded-lg border border-gray-300 bg-white text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      {getAllowedStatusOptions(r.status).map((option) => (
                        <option key={option} value={option}>
                          {option.charAt(0).toUpperCase() + option.slice(1)}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="mt-6 flex justify-center">
          <nav className="inline-flex shadow-sm rounded-md">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 border border-gray-300 text-gray-700 bg-white hover:bg-indigo-100 disabled:opacity-50"
            >
              Previous
            </button>
            {[...Array(totalPages)].map((_, idx) => (
              <button
                key={idx}
                onClick={() => paginate(idx + 1)}
                className={`px-4 py-2 border-t border-b border-gray-300 ${
                  currentPage === idx + 1
                    ? "bg-indigo-600 text-white"
                    : "bg-white hover:bg-indigo-100 text-gray-700"
                }`}
              >
                {idx + 1}
              </button>
            ))}
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 border border-gray-300 text-gray-700 bg-white hover:bg-indigo-100 disabled:opacity-50"
            >
              Next
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Reservations;